import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Option } from '../../core/models/option.model';
import { ScreenViewModule } from '../../core/directives/screen-view/_screen-view.module';
import { DEVICE_SIZE } from '../../core/models/others.model';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TooltipIconComponent } from '../tooltip-icon/tooltip-icon.component';
import { TabOptionItem } from './core/tab-option.model';

@Component({
  selector: 'tab-options',
  standalone: true,
  imports: [CommonModule, ScreenViewModule, ReactiveFormsModule, TooltipIconComponent],
  templateUrl: './tab-options.component.html',
  styleUrl: './tab-options.component.scss',
})
export class TabOptionsComponent implements OnInit, OnDestroy {
  @Input() options!: TabOptionItem[];
  @Input() currentOption!: TabOptionItem;
  @Output() currentOptionChange = new EventEmitter<any>();

  DEVICE_SIZE = DEVICE_SIZE;
  subscription = new Subscription();

  form: UntypedFormGroup = this.fb.group({
    option: [null],
  });

  constructor(protected fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.checkOption();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkOption() {
    this.subscription.add(
      this.form.get('option')?.valueChanges.subscribe(value => {
        const option = this.options.find(option => option.code === value)!;

        if (this.currentOption.code !== value) {
          this.currentOptionChange.emit(option);
        }

        this.currentOption = option;
      }),
    );

    if (this.options.length && this.currentOption.code) {
      this.form.get('option')?.setValue(this.currentOption.code, { emitEvent: false });
    }
  }

  handlerClickRadio(option: Option) {
    this.form.get('option')?.setValue(option.code);
  }
}
